import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const APKUploadForm = (props) => {
  
  const attachmentFolder = localStorage.getItem("attachmentFolder");
  const [version, setVersion] = useState("");
  const [remark, setRemark] = useState("");
  const [fileName, setFileName] = useState("");
  const [useCase, setUsecase] = useState("");
  const [AppName, setAppName] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");

  const APKUpload = (e) => {
    const file = e.target.files[0];

    if (file && file.name.endsWith(".apk")) {
      const picData = new FormData();
      picData.append("fileUpload", file, file.name);

      fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/file/${attachmentFolder}/apk/${new Date().valueOf()}/${
          file.name
        }`,
        {
          method: "POST",
          body: picData,
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setAttachmentUrl(data.url);
          setFileName(file.name);
        })
        .catch((err) => console.error(err));
    } else {
      toast.error("Please upload only APK files.");
    }
  };

  const { sendRequest: PostAPKUpload } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      empId: parseInt(localStorage.getItem("empId")),
      apkVersion: version,
      apkFilePath: attachmentUrl,
      apkRemark: remark,
      useCase: useCase,
      appName: AppName,
      serviceId: props.sId,
    };

    console.log(data);

    PostAPKUpload(
      {
        
        url: "/api/android_apk/",
        method: "POST",
        body: data,
      },
      (data) => {
        if (data) {
          toast.success(`APK ${props.update ? "Updated" : "Uploaded"}`);
          props.addForm(false);
        }
      },
      (error) => {
        console.log(error);
        toast.error(error);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">APK Upload</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>App Name</label>
                        <input
                          type="text"
                          id="appName"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={AppName}
                          onChange={(e) => setAppName(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Usecase</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          value={useCase}
                          onChange={(e) => setUsecase(e.target.value)}
                          required
                        >
                          <option value="">Select</option>
                          <option value="AdminPanel">Admin Panel</option>
                          <option value="Procurement">Procurement</option>
                          <option value="CommercialFarming">
                            Commercial Farming
                          </option>
                          <option value="Warehouse">Warehouse</option>
                          <option value="Sales">Sales</option>
                          <option value="Market Detail">Market Detail</option>
                          <option value="Agri Promoter">Agri Promoter</option>
                          <option value="Nursery">Nursery</option>
                          <option value="Warehouse Procurement">
                            Warehouse Procurement
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Remark</label>
                        <input
                          type="text"
                          id="apkRemark"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={remark}
                          onChange={(e) => setRemark(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Version</label>
                        <input
                          type="text"
                          id="apkVersion"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={version}
                          onChange={(e) => setVersion(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Upload APK:-</label> &nbsp;
                        <label className="custom-attach-upload">
                          <input
                            onChange={APKUpload}
                            type="file"
                            style={{ display: "none" }}
                          />
                          <i
                            className="fas fa-solid fa-upload"
                            style={{ cursor: "pointer" }}
                          ></i>
                        </label>
                        {fileName && (
                          <p>
                            <strong>{fileName}</strong>
                          </p>
                        )}
                        <p>
                          <strong>Note:</strong> Upload Only APK Files
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      <button
                        className="btn btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default APKUploadForm;
